import { useEffect, useRef } from 'react';
import { Typography, Stack } from '@mui/material';

import {
  MessageBox,
  MessageBubble,
  MessageStack,
} from '../../styled/MessagePanel.styled';
import { FullHeightCard } from '../../styled/Chat.styled';

import type { ChatMessage } from '../../types';

interface MessagePanelProps {
  label: string;
  messages: ChatMessage[];
}

const MessagePanel = ({ label, messages }: MessagePanelProps) => {
  const messageContainerRef = useRef<HTMLDivElement>(null);

  const scrollToLastMessage = () => {
    if (messageContainerRef.current) {
      setTimeout(() => {
        const lastChild = messageContainerRef.current?.lastElementChild;
        lastChild?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  useEffect(() => {
    scrollToLastMessage();
  }, [messages]);

  return (
    <FullHeightCard>
      <MessageBox>
        <Typography fontWeight="bold" marginBottom={2}>
          {label}
        </Typography>
        <MessageStack ref={messageContainerRef}>
          {messages.map(({ kind, text }, index) => (
            <Stack key={index}>
              <MessageBubble kind={kind}>
                <Typography>{text}</Typography>
              </MessageBubble>
            </Stack>
          ))}
        </MessageStack>
      </MessageBox>
    </FullHeightCard>
  );
};

export default MessagePanel;
